<template>
  <el-form :model="form" :rules="rules" ref="form" class="mt-2 mb-10 flex flex-col items-stretch justify-start">
    <ul class="text-xs text-blackG3 mb-10">
      <li v-for="info in uploadInfoText.split('\n')" :key="info" class="list-disc list-inside -indent-4.5 pl-4.5">
        {{ info }}
      </li>
    </ul>
    <div class="flex flex-col items-stretch justify-start gap-8">
      <div class="flex flex-wrap items-stretch justify-start gap-5">
        <el-form-item
          v-if="form.frontImage !== undefined"
          prop="frontImage"
          class="mb-0 w-full md:w-75 md:h-30"
          :inline-message="true"
          :show-message="true"
        >
          <UploadFileInput
            class="w-full h-15 md:w-75 md:h-30"
            :file="form.frontImage"
            :onFileChange="file => (form.frontImage = file)"
            placeholder="verificationStatus.clickToUploadFrontPhotoPage"
          /> </el-form-item
        ><el-form-item
          v-if="form.backImage !== undefined"
          prop="backImage"
          class="mb-0 w-full md:w-75 md:h-30"
          :inline-message="true"
          :show-message="true"
        >
          <UploadFileInput
            class="w-full h-15 md:w-75 md:h-30"
            :file="form.backImage"
            :onFileChange="file => (form.backImage = file)"
            placeholder="verificationStatus.clickToUploadBackPhotoPage"
          />
        </el-form-item>
      </div>
      <div v-if="pendingReason && pendingReason.length > 0" class="text-sm text-redG0 leading-10 whitespace-pre-line">
        {{ pendingReason }}
      </div>
      <div class="flex items-stretch justify-between flex-nowrap gap-[0.5] md:flex-wrap md:justify-start md:gap-5">
        <UploadSampleContainer
          v-for="sample in goodSamples"
          :key="`good-sample-${sample.id}`"
          :imageSize="sampleSize"
          :src="sample.src"
          :label="sample.label"
        />
        <UploadSampleContainer
          v-for="sample in badSamples"
          :key="`bad-sample-${sample.id}`"
          :imageSize="sampleSize"
          :isGood="false"
          :src="sample.src"
          :label="sample.label"
        />
      </div>
      <ul>
        <li
          v-for="criteria in criterias"
          :key="criteria.id"
          class="text-xs text-blackG3 text-opacity-70 list-disc list-inside -indent-4.5 pl-4.5"
        >
          {{ $t(criteria.label) }}
        </li>
      </ul>
    </div>
  </el-form>
</template>

<script>
import i18n from '@/lang';
import { mimeType } from '@/constants/fileMimeType';
import UploadSampleContainer from '../components/UploadSampleContainer.vue';
import UploadFileInput from '../components/UploadFileInput.vue';

export const uploadFileValidator = (rule, value, callback) => {
  if (!value) {
    if (rule.required) {
      callback(new Error(i18n.t('common.formValidation.file')));
    } else {
      callback();
    }
  } else if (!(value instanceof File)) {
    callback(new Error(i18n.t('verificationStatus.uploadTemplate.validDocumentError')));
  } else {
    const maxSize = 5 * 1024 * 1024;
    const fileType = value.type;
    if (
      !fileType.includes(mimeType['.jpg']) &&
      !fileType.includes(mimeType['.jpeg']) &&
      !fileType.includes(mimeType['.pdf'])
    ) {
      callback(new Error(i18n.t('fileUploader.supportedFormatCustom', { files: 'jpg, jpeg, pdf' })));
    }
    // Check file size
    else if (value.size > maxSize) {
      callback(new Error(i18n.t('fileUploader.maxSize', { maxSize: 5 })));
    } else {
      callback();
    }
  }
};

export default {
  components: { UploadSampleContainer, UploadFileInput },
  name: 'UploadTemplate',
  props: {
    // {frontImage: null, backImage: null}
    form: { type: Object, required: true },
    rules: { type: Object, required: true },
    // Array<id: 1, label: 'Blurry', src: BlurryIdImage>
    goodSamples: { type: Array, required: true },
    badSamples: { type: Array, required: true },
    uploadInfoText: { type: String, default: '' },
    pendingReason: { type: String, default: '' },
    sampleSize: { type: String, default: 'w-20 h-11.5 md:w-34.5 md:h-20.5' }
  },
  created() {
    this.criterias = [
      { id: 1, label: 'verificationStatus.uploadTemplate.originalAndUnedited', isNeed: true },
      { id: 2, label: 'verificationStatus.uploadTemplate.fullColourDocument', isNeed: true },
      { id: 3, label: 'verificationStatus.uploadTemplate.wholeDocumentMustBeShown', isNeed: true },
      { id: 4, label: 'verificationStatus.uploadTemplate.allInformationMustBeClearlyLegible', isNeed: true },
      { id: 5, label: 'verificationStatus.uploadTemplate.noExpiredDocuments', isNeed: false }
    ];
  },
  methods: {
    validateField(props, callback) {
      this.$refs.form?.validateField(props, callback);
    },
    validate(callback) {
      this.$refs.form?.validate((valid, rules) => {
        callback?.(valid, rules);
      });
    },
    clearValidate(props) {
      this.$refs.form?.clearValidate(props);
    }
  }
};
</script>
